<template>
  <mock-up-main>
    <div v-if="loading" class="fill-height d-flex align-center justify-center white"
         style="position: absolute; inset: 0; z-index: 10;">
      <v-progress-circular color="primary" height="5" indeterminate/>
    </div>

    <intro-slider v-if="value" v-model="computedBanner" :is-slider="false"/>

    <v-card v-if="!!value && !!value.product"
            :style="{color: !!value.product.sectionColor ? value.product.sectionColor.text : '',
             background: !!value.product.sectionColor ? value.product.sectionColor.backGround : ''}"
            class="rounded-0" flat>
      
      <v-card-title v-show="!!menuSettings.sectionTitle" class="text-center justify-center">
        {{ menuSettings.sectionTitle }}
      </v-card-title>
      
      <p v-show="!!value.product.description" class="text-center">{{ value.product.description }}</p>

      <m-category-view 
        v-model="selectedCategory" 
        :filters.sync="categoryFilter" 
        :items="value.product.items"
        :show-filter="menuSettings.showFilter"
        v-if="menuSettings.showCategories"

      />

      <div v-if="!!value.product && !!value.product.items[selectedCategory]" class="pa-2">
        <div v-for="(product, i) in getProductList" :key="i" class="rounded-lg mb-3">
          <m-product-card 
            :value="product"
            :currencySymbol="menuSettings.currency"
            :cart-button-text="menuSettings.cartButtonText"
          />
        </div>
      </div>
    </v-card>

    <ads-components
      v-else-if="!!value.product && !!value.product.items && value.product.items.length > 0" v-model="value.product"/>

    <gallery-slider
      v-if="value.PicSelector && hasGallery && value.PicSelector.slider" v-model="value.gallery"
      :description="value.PicSelector.description"
      :style="{'background':value.PicSelector.sectionColor.backGround, 'color':value.PicSelector.sectionColor.text}"
      :title="value.PicSelector.title"/>

    <b-gallery-view
      v-else-if="value && value.PicSelector" v-model="value.gallery" :description="value.PicSelector.description"
      :is-img="true"
      :style="{ background: value.PicSelector.sectionColor.backGround, color: value.PicSelector.sectionColor.text, }"
      :title="value.PicSelector.title"
    />

    <b-gallery-view
      v-if="hasVideo" v-model="value.video_gallery" :description="value.VideoGallery.description" :is-img="false"
      :style="{ background: value.VideoGallery.sectionColor.backGround, color: value.VideoGallery.sectionColor.text }"
      :title="value.VideoGallery.title"
      type="video_gallery"/>

    <b-feedback-view
      v-if="value.FeedBack && value.FeedBack.items.length > 0" v-model="value.FeedBack"/>

    <b-footer-view v-if="value.textCards" v-model="value"
                   :style="{'background' : value.textCards.sectionColor.backGround, 'color' : value.textCards.sectionColor.text}"
                   class="mt-10"/>
  </mock-up-main>
</template>

<script>
import MockUpMain from "@/view/pages/businessPage/components/mockUp";
import IntroSlider from "@/view/pages/businessPage/components/view/bIntroSliderView";
import MCategoryView from "@/view/pages/otherQrTypes/menu/cm/mCategoryView";
import AdsComponents from "@/view/components/Product/AdsComponents";
import BFooterView from "@/view/pages/businessPage/components/view/bFooterView";
import GallerySlider from "@/view/pages/businessPage/components/view/gallerySlider";
import BGalleryView from "@/view/pages/businessPage/components/view/bGalleryView";
import BFeedbackView from "@/view/pages/businessPage/components/view/bFeedbackView";
import MProductCard from "@/view/components/Product/mProductCard.vue";

export default {
  name: "viewMenu",

  components: {
    MProductCard,
    BFeedbackView,
    BGalleryView, GallerySlider, BFooterView, AdsComponents, MCategoryView, IntroSlider, MockUpMain
  },

  props: {
    value: Object,
    loading: Boolean
  },

  data: () => ({
    selectedCategory: 0,
    categoryFilter: {
      sub: null
    }
  }),

  computed: {
        menuSettings() {
      const rawSettings = (this.value && this.value.settings) ? this.value.settings : {};
      const customLabels = rawSettings.customLabels || {};
      
      const businessType = rawSettings.businessType || 'restaurant';

      const titleKeys = {
        cafe: 'settings.custom_labels.ph_menu_cafe',             
        restaurant: 'settings.custom_labels.ph_menu_restaurant', 
        fastfood: 'settings.custom_labels.ph_menu_fastfood',     
        icecream: 'settings.custom_labels.ph_menu_icecream',     
        sweets: 'settings.custom_labels.ph_menu_sweets',         
        bakery: 'settings.custom_labels.ph_menu_bakery'          
      };

      const smartDefaultTitle = titleKeys[businessType] 
        ? this.$t(titleKeys[businessType]) 
        : this.$t('settings.custom_labels.ph_product_list');

      const isFoodMenu = ['cafe','restaurant','fastfood','icecream'].includes(businessType);
      const smartDefaultCartBtn = isFoodMenu 
        ? this.$t('settings.custom_labels.ph_add_order') 
        : this.$t('settings.custom_labels.ph_add_cart'); 

      let finalTitle = customLabels.productsTitle;
      if (finalTitle && (finalTitle.includes('settings.') || finalTitle.includes('ph_'))) {
        finalTitle = this.$t(finalTitle);
      }
      if (!finalTitle) {
        const oldTitle = this.value?.product?.title;
        const oldDefaults = ['محصولات', 'منوی سفارش', 'منوی رستوران', 'منوی کافه'];
        if (oldTitle && !oldDefaults.includes(oldTitle)) {
          finalTitle = oldTitle;
        } else {
          finalTitle = smartDefaultTitle;
        }
         if (oldTitle && oldTitle.includes('settings.')) {
            finalTitle = smartDefaultTitle;
        } else if (oldTitle && !oldDefaults.includes(oldTitle)) {
          finalTitle = oldTitle;
        } else {
          finalTitle = smartDefaultTitle;
        }
      }
      
      const finalCartBtn = customLabels.cartButton || smartDefaultCartBtn;

      let finalCurrency = 'ریال';
      
      if (rawSettings.currency) {
        if (typeof rawSettings.currency === 'string') {
          finalCurrency = rawSettings.currency;
        } else if (typeof rawSettings.currency === 'object') {
          finalCurrency = rawSettings.currency.text || rawSettings.currency.value || 'ریال';
        }
      }

      return {
        businessType: businessType,
        currency: finalCurrency, 
        showFilter: rawSettings.showFilter !== false,
        showCategories: rawSettings.showCategories !== false, 
        sectionTitle: finalTitle,
        cartButtonText: finalCartBtn
      };
    },

    computedBanner() {
      if (this.value?.banner?.gallery && this.value.banner.gallery[0])
        return {
          banner: this.value.banner.gallery[0]
        }
      else {
        return null
      }
    },
    hasGallery() {
      return this.value.gallery?.length > 0 && this.value.gallery?.filter(item => item.images?.length > 0)?.length > 0
    },
    hasVideo() {
      return !!this.value.VideoGallery && !!this.value.video_gallery?.filter(g => !!g.images.length)?.length
    },
    getProductList() {
      const getProductsRecursive = (item) => {
        let productsList = [];

        if (item?.children?.length) {
          item.children.forEach(child => {
            if (this.categoryFilter.sub == null || (child.id || child.slug) === this.categoryFilter.sub) {
              productsList = productsList.concat(getProductsRecursive(child));
            }
          });
        } else {
          productsList = item?.products || [];
        }

        return productsList;
      };

      if (!this.value?.product?.items) return [];

      return this.value.product.items
        .filter((item, index) => index === this.selectedCategory)
        .map(item => getProductsRecursive(item))
        .filter(list => list.length > 0)
        .flat();
    }
  },

  watch: {
    value: {
      deep: true,
      handler() {
        this.$forceUpdate()
      }
    }
  },
}
</script>

<style>
pre {
  font-family: Vazir, serif !important;
  white-space: break-spaces;
  overflow: hidden;
  text-wrap: wrap;
}
</style>
